package screens.list

import common.EConstants
import common.ECssClasses
import components.ButtonContent
import components.Toolbar
import components.burgerMenu.BurgerMenu
import core.enums.ELocalizationKeys
import core.extensions.toClassName
import core.extensions.useCoroutineScope
import core.io.CustomHttpClient
import core.io.dto.SceneDTOIn
import core.ionic.EmptyProps
import core.ionic.IonButton
import core.ionic.IonCol
import core.ionic.IonContent
import core.ionic.IonGrid
import core.ionic.IonHeader
import core.ionic.IonPage
import core.ionic.IonRow
import core.localization.Localization
import csstype.Display
import csstype.JustifyContent
import csstype.Margin
import csstype.ObjectFit
import csstype.ObjectPosition
import csstype.Overflow
import csstype.number
import csstype.pct
import csstype.px
import emotion.react.css
import kotlinx.coroutines.launch
import react.FC
import react.dom.html.ReactHTML.img
import react.router.Navigate
import react.router.useNavigate
import react.useEffectOnce
import react.useState
import screens.EScreens

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 04.11.22
 * Author : leonhergt
 */

val GalleryScreen = FC<EmptyProps> {


    val mClient = CustomHttpClient()
    val mScope = useCoroutineScope()

    var mSceneList: List<SceneDTOIn> by useState(emptyList())

    var mTargetScreen: String? by useState(null)
    val mNavigate = useNavigate()

    useEffectOnce {
        mScope.launch {
            mSceneList = mClient.getGalleryImages()
        }
    }

    BurgerMenu()
    IonPage {
        id = EConstants.BURGER_MENU_CONTENT.mId

        IonHeader {
            Toolbar() {
            }
        }
        IonContent {
            IonGrid {
                css(ECssClasses.VERTICAL_GRID.toClassName(), ECssClasses.NON_SCROLLABLE_GRID.toClassName()) {}
                IonRow {
                    css() {
                        flexGrow = number(1.0)
                        overflow = Overflow.scroll
                    }
                    mSceneList.forEach { scene ->
                        IonCol {
                            size = "12"
                            sizeMd = "6"
                            img {
                                css(ECssClasses.CURSOR_HOVER.toClassName()) {
                                    height = 278.px
                                    width = 100.pct
                                    objectFit = ObjectFit.cover
                                    objectPosition = ObjectPosition.center
                                }
                                src = scene.mImageUrl
                                onClick = {
                                    mTargetScreen = EScreens.WALL_COLOURER_MODULE_SCREEN(
                                        EScreens.EColoursOnWallType.SCENE,
                                        scene.mId.toString()
                                    ).mPath
                                }
                            }
                        }
                    }
                }
                IonRow {
                    css {
                        margin = Margin(top = 28.px, horizontal = 20.px, bottom = 28.px)
                    }
                    IonCol {
                        css {
                            justifyContent = JustifyContent.spaceBetween
                            display = Display.flex
                            padding = 0.px
                        }
                        IonButton {
                            css(ECssClasses.SECONDARY_BUTTON.toClassName()) {
                                width = 165.px
                            }
                            onClick = {
                                mNavigate.invoke(-1)
                            }
                            ButtonContent {
                                mContent =
                                    Localization.getLocalizationKey(ELocalizationKeys.CORE_BACK.name)
                            }
                        }
                    }
                }
            }
        }
    }

    mTargetScreen?.let {
        Navigate {
            to = it
        }
    }

}